import { SectionMeta } from "../components/SectionMeta.jsx";

const FEELINGS = [
  { id: "A", label: "Talent feels undervalued.", verdict: "we hear them" },
  { id: "B", label: "Clients feel disappointed.", verdict: "repeatedly" },
  { id: "C", label: "Agencies feel burnt out.", verdict: "visibly" },
  { id: "D", label: "Builders are stuck between the three.", verdict: "no longer" },
];

export function Problem() {
  return (
    <section className="section shell" id="problem">
      <SectionMeta num="§ 01" label="The state of things" right="A note before we begin" />

      <div className="problem-grid">
        <h2 className="h-large reveal">
          The system is <span className="strike">working</span> <em>broken.</em>
        </h2>

        <div className="reveal problem-lead-offset">
          <p className="lead lead-flush">
            The marketing and technology world has become transactional,
            exhausting, fragmented, uninspiring.
          </p>
          <p className="body body-muted body-narrow">
            Everyone is busy. Very few are fulfilled. We think there&apos;s a
            better way to build.
          </p>
        </div>
      </div>

      <ul className="feelings reveal feelings-spaced">
        {FEELINGS.map((item) => (
          <li key={item.id}>
            <span className="mono">{item.id}.</span>
            <span className="label">{item.label}</span>
            <span className="verdict">{item.verdict}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
